export default __webpack_public_path__ + "static/media/ic_map_asia.fa4eac62.svg";